import { getToken } from '@/utils/adminAuth'
import { resolveUploadUrl } from './categories'
import { request } from './http'

function resolveApiBase() {
  const fromEnv = process.env.VUE_APP_API_BASE
  if (fromEnv != null && String(fromEnv).trim() !== '') {
    return String(fromEnv).replace(/\/$/, '')
  }
  return ''
}

export { resolveUploadUrl }

export function fetchBanners() {
  return request('/api/admin/banners')
}

export function fetchPublicBanners() {
  return request('/api/banners')
}

export function createBanner(data) {
  return request('/api/admin/banners', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

export function updateBanner(id, data) {
  return request(`/api/admin/banners/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

export function deleteBanner(id) {
  return request(`/api/admin/banners/${id}`, {
    method: 'DELETE'
  })
}

export function mapStorefrontBanner(row) {
  return {
    id: row.id,
    imageUrl: resolveUploadUrl(row.image_url || row.image_path || '')
  }
}

export async function uploadBannerImage(file) {
  const formData = new FormData()
  formData.append('file', file)

  const headers = {}
  const token = getToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const res = await fetch(`${resolveApiBase()}/api/admin/banners/upload`, {
    method: 'POST',
    headers,
    body: formData
  })

  let body = null
  const text = await res.text()
  if (text) {
    try {
      body = JSON.parse(text)
    } catch {
      body = { code: res.status, message: text }
    }
  }

  if (!res.ok) {
    const err = new Error(body?.message || res.statusText || '上传失败')
    err.code = body?.code ?? res.status
    throw err
  }

  return body
}
